<template>
  <g>
    <path d="M75 337.5 A175 175 0 0 1 425 337.5 Z" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
    <path :d="sides.b.border.line" stroke="#353535" stroke-width="1" fill="none"/>
    <line :x1="sides.a.border.line.xStart" :y1="sides.a.border.line.yStart" :x2="sides.a.border.line.xEnd" :y2="sides.a.border.line.yEnd" stroke="#353535" stroke-width="1"/>
      <g v-for="(side, index) in sides" :key="index">
        <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#353535" stroke-width="1" fill="#353535"/>
        <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#353535" stroke-width="1" fill="#353535"/>
      </g>
    <text v-for="side in sides" :key="side.id" :x="side.labelSpace.x" :y="side.labelSpace.y" font-weight="bold" font-family="sans-serif" font-size="2.5em" fill="#232323">{{side.name}}</text>
    <g v-if="sides.b.rand === saum">
      <path :d="sides.b.saum" stroke="#b1b1b1" stroke-width="1" stroke-dasharray="3,3" :fill="material.color.hex"/>
      <g v-if="sides.b.rand.oesenArt != inactiveOesen">
        <circle v-for="(item, index) in sides.b.oesenAnzahl" :key="index" :cx="sides.b.oesenAbstand.x(index, sides.b.oesenAnzahl)" :cy="sides.b.oesenAbstand.y(index, sides.b.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
      </g>
    </g>
    <path v-if="sides.b.rand === hohlsaum" :d="sides.b.hohlsaum" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
    <g v-if="sides.a.rand === saum">
      <path :d="sides.a.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
      <g v-if="sides.a.rand.oesenArt != inactiveOesen">
        <circle v-for="(item, index) in sides.a.oesenAnzahl" :key="index" :cx="sides.a.oesenAbstand.x(index, sides.a.oesenAnzahl)" :cy="sides.a.oesenAbstand.y(index, sides.a.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
      </g>
    </g>
    <path v-if="sides.a.rand === hohlsaum" :d="sides.a.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
  </g>
</template>

<script>
import DataRand from '../../../../../data/main/config/setup/rand/randArt'

export default {
  props: ['material', 'rand'],
  data () {
    return {
      saum: DataRand.randArt.saum.titleSaum.name,
      hohlsaum: DataRand.randArt.hohlsaum.title.name,
      inactiveOesen: DataRand.randArt.saum.optionsOesenart[0].value.oesenArt
    }
  },
  computed: {
    sides () {
      return {
        a: {
          name: 'a',
          rand: this.rand.a.type,
          oesenAnzahl: this.rand.a.type === this.saum ? this.rand.a.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: 250 - Math.sqrt(Math.pow(160, 2) - Math.pow(15, 2)),
            xEnd: 250 + Math.sqrt(Math.pow(160, 2) - Math.pow(15, 2)),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return 322.5
            }
          },
          saum: 'M' + (250 - Math.sqrt(Math.pow(175, 2) - Math.pow(30, 2))) + ' 307.5 L' + (250 + Math.sqrt(Math.pow(175, 2) - Math.pow(30, 2))) + ' 307.5',
          hohlsaum: 'M' + (250 - Math.sqrt(Math.pow(175, 2) - Math.pow(9, 2))) + ' 328.5 L' + (250 + Math.sqrt(Math.pow(175, 2) - Math.pow(9, 2))) + ' 328.5',
          labelSpace: {
            x: 245,
            y: 395
          },
          border: {
            line: {
              xStart: 75,
              yStart: 357.5,
              xEnd: 425,
              yEnd: 357.5
            },
            corner: {
              start: '75,357.5 85,352.5 85,362.5',
              rotateStart: 'rotate(0, 75, 357.5)',
              end: '425,357.5 415,352.5 415,362.5',
              rotateEnd: 'rotate(0, 425, 357.5)'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          rand: this.rand.b.type,
          oesenAnzahl: this.rand.b.type === this.saum ? this.rand.b.oesenAnzahl : 0,
          oesenAbstand: {
            radius: 350 / 2 - 15,
            centerX: (350 / 2) + 75,
            centerY: 350 / 2 + 75 + 87.5,
            xStart: 250 - Math.cos(Math.asin(3 / 32)) * 160,
            xEnd: 250 + Math.cos(Math.asin(3 / 32)) * 160,
            x: function (i, item) {
              if (item === 1) {
                return 250
              } else {
                return Math.cos((-Math.PI + 2 * Math.asin(3 / 32)) / (item - 1) * i - Math.asin(3 / 32)) * this.radius + this.centerX
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return Math.sin((270 * (Math.PI / 180))) * this.radius + this.centerY
              } else {
                return Math.sin((-Math.PI + 2 * Math.asin(3 / 32)) / (item - 1) * i - Math.asin(3 / 32)) * this.radius + this.centerY
              }
            }
          },
          saum: 'M105 337.5 A145 145 0 0 1 395 337.5',
          hohlsaum: 'M84 337.5 A166 166 0 0 1 416 337.5',
          labelSpace: {
            x: 245,
            y: 125
          },
          border: {
            line: 'M55 337.5 A195 195 0 0 1 445 337.5',
            corner: {
              start: '55,337.5 50,327.5 60,327.5',
              rotateStart: 'rotate(0, 55, 337.5)',
              end: '445,337.5 440,327.5 450,327.5',
              rotateEnd: 'rotate(0, 445, 337.5)'
            }
          },
          id: 2
        }
      }
    }
  }
}
</script>

<style>
</style>
